/**
 * The assistant's mark - a compass rose.
 *
 * Drawn rather than typed. Every circled and starred codepoint we tested was
 * tofu in the deployed font set (`ⓘ`, `🛈`, `Ⓘ`), and a star is no safer than a
 * circled i; an inline path renders identically everywhere and scales without
 * hinting against us.
 *
 * A rose rather than a sparkle because this is a maritime application: the
 * shape belongs to the same world as the charts it is drawing, which the
 * generic AI twinkle does not.
 */

import { html, type TemplateResult } from 'lit';

export function assistantMark(size = 16): TemplateResult {
  return html`<svg
    width=${size}
    height=${size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    class="assistant-mark"
  >
    <path
      d="M12 2.2 13.8 9l5-3.8-3.8 5 6.8 1.8-6.8 1.8 3.8 5-5-3.8L12 21.8 10.2 15l-5 3.8 3.8-5L2.2 12 9 10.2l-3.8-5 5 3.8L12 2.2Z"
      fill="currentColor"
    />
  </svg>`;
}
